import { render } from "./EdicionMarcaCpes.vue?vue&type=template&id=d47a5e1c&scoped=true"
import script from "./EdicionMarcaCpes.vue?vue&type=script&lang=js"
export * from "./EdicionMarcaCpes.vue?vue&type=script&lang=js"

import "./EdicionMarcaCpes.vue?vue&type=style&index=0&id=d47a5e1c&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47a5e1c"]])

export default __exports__